import { Module } from "vuex";
import RootState from "./root-state";
import {
  getUnreadMessageCount,
  MessageMap,
  PayloadMessage
} from "@/api/message-api";

export default {
  namespaced: false,

  state: {
    unreadMessages: {} as { [key: number]: MessageMap }
  },

  getters: {
    getUnreadMessages(state) {
      return state.unreadMessages;
    },

    totalUnreadMessage(state) {
      return Object.values(state.unreadMessages).reduce(
        (sum, value) => sum + value.count,
        0
      );
    },

    existsNotTaggedUnreadMessage(state) {
      return Object.values(state.unreadMessages).some(
        value => value.hasUntaggedUnreadMessages
      );
    }
  },

  mutations: {
    unreadMessages(state, unreadMessages: PayloadMessage[]) {
      const updatedMessages: { [key: number]: MessageMap } = {};
      unreadMessages.forEach((item: PayloadMessage) => {
        updatedMessages[item.projectId] = {
          count: item.count,
          hasUntaggedUnreadMessages: item.hasUntaggedUnreadMessages
        };
      });
      state.unreadMessages = updatedMessages;
    },

    updateCountUnreadMessage(state, payload: PayloadMessage) {
      state.unreadMessages[payload.projectId] = {
        count: payload.count,
        hasUntaggedUnreadMessages: payload.hasUntaggedUnreadMessages
      };
    }
  },

  actions: {
    async getUnreadMessage({ commit }) {
      const unreadMessages = await getUnreadMessageCount();
      commit("unreadMessages", unreadMessages);
    },

    async updateCountUnReadMessage({ commit }, payload: PayloadMessage) {
      commit("updateCountUnreadMessage", payload);
    }
  }
} as Module<MessageState, RootState>;

interface MessageState {
  unreadMessages: { [key: number]: MessageMap };
}
